import React, { Component } from "react";
import {
    FormControl,
    Button, 
    Glyphicon, 
    DropdownButton,
    MenuItem,
    InputGroup,
    Table
   } from "react-bootstrap";
   
export default class AlertScalation extends Component {
    constructor(props) {
        super(props);

        this.state = {
            index: props.index,
            confirmed: props.confirmed || false,
            level: props.level || 1,
            time: props.time || 0,
            emails: props.emails || '',
            emailType: props.emailType || 'TO',
            emailTypeTitle: "Para"
        }

        this.emailTypeOptions = [
            {
                id: "TO",
                value: "Para"
            }, {
                id: "CC",
                value: "Copia"
            }, {
                id: "BCC",
                value: "C Oculta"
            }
        ]
    }

    handleChangeLevel = (e) => {
        this.setState({level: e.target.value});
    }

    handleChangeTime = (e) => {
        this.setState({time: e.target.value});
    }

    handleChangeEmailType = (eventKey, event) => {
        let emailType = this.emailTypeOptions.find(emailType => {
            return emailType.value === event.target.text;
        });
        this.setState({emailTypeTitle: event.target.text, emailType: emailType.id});
    }

    handleConfirm = () => {
        new Promise((resolve) => {
            this.setState({confirmed: true});
            resolve();
        }).then(() => {
            this.props.onConfirm(this.state);
        });
    }

    handleRemove = () => {
        this.props.onRemove(this.state);
    }

    handleChangeEmails = (e) => {
        this.setState({emails: e.target.value});
    }

    render() {
        return (
            <div className="AlertScalation">
                <Table>
                <tbody>
                <tr>
                    <td width="20%">
                    {
                        this.state.confirmed ? this.state.level :
                        <FormControl componentClass="select" placeholder="Nivel" onChange={this.handleChangeLevel} value={this.state.level}>
                            <option value="1">1</option>
                            <option value="2">2</option>
                            <option value="3">3</option>
                        </FormControl>
                    }
                    </td>
                    <td width="20%">
                    {
                        this.state.confirmed ? this.state.time :
                        <FormControl type="text" onChange={this.handleChangeTime} value={this.state.time} />
                    }
                    </td>
                    <td width="70%">
                    {
                        this.state.confirmed ? this.state.emailType + ': ' + this.state.emails :
                        <InputGroup>
                            <FormControl type="text" placeholder="Emails" onChange={this.handleChangeEmails} />
                            <DropdownButton 
                                componentClass={InputGroup.Button} 
                                title={this.state.emailTypeTitle}
                                onSelect={this.handleChangeEmailType}
                                id="emailType">
                                    <MenuItem key="TO">Para</MenuItem>
                                    <MenuItem key="CC">Copia</MenuItem>
                                    <MenuItem key="BCC">C Oculta</MenuItem>
                            </DropdownButton>
                        </InputGroup>
                    }
                    </td>
                    <td width="10%">
                    {
                        !this.state.confirmed ?
                        <Button bsSize="xsmall" onClick={this.handleConfirm}>
                            <Glyphicon glyph="ok" />
                        </Button> 
                        :
                        ''
                    }
                    <Button bsSize="xsmall" onClick={this.handleRemove}>
                        <Glyphicon glyph="remove" />
                    </Button>
                    </td>
                </tr>
                </tbody>
            </Table>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/containers/alert/AlertScalation.js